<template>
  <div class="rating">
    <div v-if="readOnly">
      <SvgIcon
        class="icon star"
        :title="rate.text"
        :height="size"
        :width="size"
        :icon="rate.value <= selectedRate ? 'StarSelected' : 'StarUnselected'"
        v-for="rate in rateItems"
        :key="rate.value"
        @click.native="openRatingModal(rate.value)"
      />
    </div>
    <div v-else class="active-rating d-flex">
      <div class="rating__label">
        {{ rateLabel }}
      </div>
      <span
        v-for="rate in rateItems"
        :key="rate.value"
        @click="onSelectRate(rate.value)"
        @mouseenter="onHoverIcon(rate.value)"
        @mouseleave="onHoverIcon(0)"
      >
        <!-- <SvgIcon
          class="icon star"
          :height="size"
          :width="size"
          :icon="isActiveRate(rate.value) ? 'StarSelected' : 'StarUnselected'"
        /> -->
        <img
          v-if="isActiveRate(rate.value)"
          src="https://vncdn.ahamove.com/images/fc0631cc936d1625505344.png"
          :height="size"
          :width="size"
        />

        <img
          v-else
          src="https://vncdn.ahamove.com/images/gg38e483j2951625505395.png"
          :height="size"
          :width="size"
        />
      </span>

      <!-- <div class="rating__icon">
        <SvgIcon v-if="rateIcon" height="65" width="65" :icon="rateIcon" />
      </div> -->
      <!-- <div class="rating__label">
        {{ rateLabel }}
      </div> -->
    </div>
  </div>
</template>

<script>
export default {
  props: {
    readOnly: {
      type: Boolean
    },
    rateValue: {
      type: Number
    },
    disabledRating: {
      type: Boolean
    },
    size: {
      type: String,
      default: '32'
    }
  },
  data() {
    return {
      rateItems: [
        { value: 1, text: this.$t('rating.value_label.1') },
        { value: 2, text: this.$t('rating.value_label.2') },
        { value: 3, text: this.$t('rating.value_label.3') },
        { value: 4, text: this.$t('rating.value_label.4') },
        { value: 5, text: this.$t('rating.value_label.5') }
      ],
      rateMouseOver: 0,
      selectedRate: 0
    }
  },
  computed: {
    rateLabel() {
      const selectedRate = this.rateMouseOver > 0 ? this.rateMouseOver : this.selectedRate

      return selectedRate > 0 ? this.$t('rating.value_label.' + selectedRate) : ''
    },
    rateIcon() {
      const selectedRate = this.rateMouseOver > 0 ? this.rateMouseOver : this.selectedRate

      return selectedRate > 0 ? `Rating${selectedRate}` : ''
    }
  },
  methods: {
    onHoverIcon(value) {
      this.rateMouseOver = value
      if (this.selectedRate === 0) {
        this.selectedRate = value
      }
    },
    onSelectRate(value) {
      if (this.selectedRate === value) return

      this.selectedRate = value
      this.$emit('onChangeRateValue', this.selectedRate)
      this.$analyticTracking.logEvent(
        this.$trackingEvents.ACTIONS.CLICK,
        this.$trackingEvents.EVENTS.RATE_SUPPLIER_RATE_CLICK,
        {
          rateValue: this.selectedRate
        }
      )
    },
    openRatingModal(value) {
      if (this.disabledRating) return
      this.$emit('onChangeRateValue', value)
      this.$emit('onOpenModal')
    },
    isActiveRate(value) {
      if (this.rateMouseOver > 0) return value <= this.rateMouseOver
      return value <= this.selectedRate
    }
  },
  watch: {
    rateValue(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.selectedRate = this.rateValue
      }
    }
  },
  beforeMount() {
    this.selectedRate = this.rateValue
  }
}
</script>

<i18n src="@/locales2/share/ratingValue.json"></i18n>

<style lang="scss">
.rating-modal__rate {
  .rating {
    width: 100%;
  }
}

.rating {
  .icon {
    &.star {
      display: inline-block;
      cursor: pointer;
      margin: 0;
      color: #d8d8d8;
      transition: color 0.3s ease-in;

      &:not(:last-child) {
        margin-right: 10px;
      }

      &.active {
        color: #fecf5f;
      }
    }
  }

  .active-rating {
    max-width: 100%;
    // overflow: hidden;
    border: 1px solid #f5f5f5;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
    border-radius: 4px;
    align-items: center;

    span {
      margin-right: 5px;
    }
    // .icon.star {
    //   padding: 12px 0;
    //   &:hover {
    //     color: #fecf5f;
    //   }
    // }
  }

  .rate-label {
    display: inline-block;
    min-height: 15px;
  }

  .rating__icon {
    min-height: 97px;
    padding: 20px 0 12px;

    > div {
      margin: 0 auto;
    }
  }

  .rating__label {
    text-align: left;
    padding-left: 10px;
    font-size: 16px;
    height: 56px;
    line-height: 56px;
    width: 50%;
    color: #1a1a1a;
    font-weight: 500;
  }
}
@media screen and (max-width: 414px) {
  .max-width-container-lg {
    max-width: 1440px;
  }
}
</style>
